export default __webpack_public_path__ + "00e4de95b315b83ebc66544c3e11c717.svg";